import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fluent UI Imports

import useWindowSize from "../../../helpers/useWindowSize";
import { useNavigate } from "react-router-dom";
import { Link, Text } from "@fluentui/react-components";
import { ErrorCircleSettingsRegular } from "@fluentui/react-icons";

var emailRegEx = /\S+@\S+\.\S+/;

function MaintenanceMode(props: any) {
  const windowSize = useWindowSize();
  const navigate = useNavigate();

  return (
    <div>
      <div className="blockContainerContentCentered">
        <div
          style={{
            borderRadius: "11px",
            backgroundColor: "white",
            boxShadow: "0px 6px 12px 5px silver",
            minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
            maxWidth: 500,
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            marginBottom: 20,
            animationDuration: "4s",
          }}
        >
          <div style={{ padding: "20px" }}>
            <Link onClick={() => navigate("/")}>
              <img
                alt="Lübbering Logo"
                src={"/Logo-Luebbering-100-schwarz.svg"} //TODO: Logo ändern? --Lutz
                height={20}
                className="lueb-MarginBottom30"
              />
            </Link>
            <div className="lueb-padding5 lueb-MarginTopBottom10">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ErrorCircleSettingsRegular
                  style={{ fontSize: "50px", color: "rgb(255, 102, 0)" }}
                />
              </div>

              <div style={{ marginTop: 20 }}>
                <Text>{i18n.t<string>("maintenanceMode")}</Text>
              </div>

              <div style={{ marginTop: 20 }}>
                <hr
                  style={{
                    borderTop: "1px solid #ff6600",
                    padding: 0,
                    height: 1,
                  }}
                />
              </div>

              {i18n.language.includes("de") && (
                <div style={{ marginTop: 5 }}>
                  <Text block>Anbieter von LÜBBERING DIGITAL ist:</Text>

                  <div style={{ marginTop: 20 }}>
                    <Text>Johannes Lübbering GmbH</Text>
                    <Text block>Industriestraße 4</Text>
                    <Text block>33442 Herzebrock-Clarholz</Text>
                    <Text block>Deutschland</Text>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <Text block>Telefon: +49 (0) 5245 - 8309 0</Text>
                    <Text block>E-Mail: info@luebbering.de</Text>
                  </div>
                  <Text block>Geschäftsführer: Achim Lübbering</Text>
                </div>
              )}
              {!i18n.language.includes("de") && (
                <div style={{ marginTop: 5 }}>
                  <Text block>The provider of LÜBBERING DIGITAL is:</Text>

                  <div style={{ marginTop: 20 }}>
                    <Text>Johannes Lübbering GmbH</Text>
                    <Text block>Industriestraße 4</Text>
                    <Text block>33442 Herzebrock-Clarholz</Text>
                    <Text block>Germany</Text>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <Text block>Telephone: +49 (0) 5245 - 8309 0</Text>
                    <Text block>E-Mail: info@luebbering.de</Text>
                  </div>
                  <Text block>Managing Director: Achim Lübbering</Text>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceMode;
